import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { ListStore, Store } from './store';
import Wrap from './Wrap';

const Layout = ({ content }) => {
    const { params, live } = content;
    const { id } = params;

    return (
        <ListStore.Provider>
            <Store.Provider>
                <Wrap content={{ id, live }} />
            </Store.Provider>
        </ListStore.Provider>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
